export const customerHubMainFooterStacks = [
  {
    heading: 'About Us',
    id: 'footerAboutUs',
    items: [
      {
        label: 'About Best Egg',
        url: 'https://www.bestegg.com/about/',
      },
      {
        label: 'Best Egg Personal Loans',
        url: 'https://www.bestegg.com/personal-loans/',
      },
      {
        label: 'Best Egg Credit Cards',
        url: 'https://www.bestegg.com/credit-card/',
      },
      {
        label: 'Best Egg Financial Health',
        url: 'https://www.bestegg.com/financial-health/',
      },
      {
        label: 'Best Egg Reviews',
        url: 'https://www.bestegg.com/customer-reviews/',
      },
    ],
  },
  {
    heading: 'Legal',
    id: 'footerLegal',
    items: [
      {
        label: 'Privacy Policy',
        url: 'https://www.bestegg.com/privacy-policy/',
      },
      {
        label: 'Terms of Use',
        url: 'https://www.bestegg.com/terms-of-use/',
      },
      {
        label: 'Licenses',
        url: 'https://www.bestegg.com/licenses/',
      },
      {
        label: 'Accessibility',
        url: 'https://www.bestegg.com/accessibility/',
      },
    ],
  },
  {
    heading: 'Questions',
    id: 'footerQuestions',
    items: [
      {
        label: 'FAQ',
        url: 'https://support.bestegg.com/hc/en-us',
      },
      {
        label: 'Contact Us',
        url: 'https://www.bestegg.com/contact-us/',
      },
      {
        label: 'Blog',
        url: 'https://www.bestegg.com/blog/',
      },
    ],
  },
];

export const customerHubPressFooterStack = {
  heading: 'Hear More About Us',
  id: 'footerPress',
  items: [
    {
      label: 'Press',
      url: 'https://www.bestegg.com/press/',
    },
  ],
};
